import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SingleList from './SingleList';
import { setSingleGroupListInfoM } from '@Redux/search/actions';
import { RootState } from '@Redux/search/store';
import { useMediaQuery } from 'react-responsive';
import { I_SingleGroup } from '@Redux/search/interfaces';
import styles from '../styles.module.scss';
import getResultConditions from '@utils/getResultConditions';
import ResultNoData from '@components/SearchPage/ResultNoData';
import Spinner from '@components/Common/Spinner';

interface I_Props {
    setIsContactStaffOpen: Function;
}

const M = ({ setIsContactStaffOpen }: I_Props) => {
    const search = useSelector((state: RootState) => state.search);
    const {
        SingleGroupListInfoM,
        DepthInfo,
        FilterItems,
        SortListBy,
        TagFiltersShow,
        ChangeItem,
        Tags,
        callJson,
    } = search;

    const curPage = location.pathname;

    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    const dispatch = useDispatch();

    const { data, isLoading, PageSize } = SingleGroupListInfoM;

    const resultConditions = getResultConditions({
        FilterItems,
        DepthInfo,
        SortListBy,
        TagFiltersShow,
        search,
    });

    const urlParams = new URLSearchParams(window.location.search);

    useEffect(() => {
        if (isMobile) {
            const reqBody = {
                ...resultConditions,
                Page: 1,
                PageSize: 10,
            };
            dispatch(setSingleGroupListInfoM(reqBody));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, resultConditions.TripTypes, Tags]);

    useEffect(() => {
        if (ChangeItem) {
            if (isMobile) {
                const reqBody = {
                    ...resultConditions,
                    Page: 1,
                    PageSize: 10,
                };
                dispatch(setSingleGroupListInfoM(reqBody));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [FilterItems, DepthInfo, SortListBy, TagFiltersShow]);

    // 載入更多
    const loadingMorePage = () => {
        const reqBody = {
            ...resultConditions,
            Page: 1,
            PageSize: PageSize + 10,
        };
        dispatch(setSingleGroupListInfoM(reqBody));
    };

    return (
        <>
            {/* if 點"更多精彩行程"按鈕，保留原本列表的高度
                else (更換搜尋條件)，只留下 Loading 圖 */}
            {(PageSize > 10 || !isLoading) &&
                data?.SingleGroupList.map((item: I_SingleGroup, i: number) => (
                    <SingleList
                        key={i}
                        groupData={item}
                        setIsContactStaffOpen={setIsContactStaffOpen}
                    />
                ))}
            {/* if Loading 完成且確實沒有資料，顯示"查無資料" */}
            {!isLoading && data?.SingleGroupList.length === 0 && <ResultNoData />}
            {isLoading && <Spinner />}
            {/* if 正在 Loading 或 沒有更多資料了，則不顯示"更多精彩行程"按鈕 */}
            {isLoading || PageSize >= data!.TotalCount ? null : (
                <div className={styles.moreInfoWrapper}>
                    <div className={styles.moreInfo} onClick={loadingMorePage}>
                        更多精彩行程
                    </div>
                </div>
            )}
        </>
    );
};

export default M;
